import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M13.332 7.4V5.5h.4a.624.624 0 0 0 .35-1.191L7.923.35a1.35 1.35 0 0 0-1.382 0L.382 4.309a.65.65 0 0 0-.359.753c.1.297.398.481.709.438h.4v7.513A1.025 1.025 0 0 0 .2 14.1v.95a.977.977 0 0 0 1 .95h10.3a4.5 4.5 0 0 0 1.832-8.6m-6.25-6.209a.37.37 0 0 1 .3 0L12.528 4.5H1.934zm5.25 4.309v1.584A4.5 4.5 0 0 0 11.5 7q-.49.003-.968.11V5.5zm-2.8 0v1.971a4.5 4.5 0 0 0-1.8 1.58V5.5zm-2.8 0V13h-1.8V5.5zm-2.8 0V13h-1.8V5.5zM1.2 15.05V14h6.56c.267.388.593.732.966 1.019zM11.5 15a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7m2-4H12V9.5a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1" />
  </svg>
);
const SvgAddBank = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="add-bank" {...props} />;
export default SvgAddBank;
